import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import ContractForm from 'pricing/components/contract/contractForm/ContractForm';
import ContractNotFound from 'pricing/components/contract/contractNotFound/ContractNotFound';
import { PricingLayoutPageHeaderStyled } from 'pricing/components/layout/PricingLayout.styles';
import LoadingPage from 'pricing/components/loadingPage/LoadingPage';
import { useContractState } from 'pricing/components/contract/useContractState/useContractState';
import ContractEditHeaderAction from 'pricing/components/contract/contractEditHeaderAction/ContractEditHeaderAction';
import { fetchContract } from 'pricing/utilities/contract/fetchContract/fetchContract';
import { testId } from 'pricing/utilities/test/dataTestId';
import { PricingRouteContractEditParams, PricingRoutes } from 'pricing/types';
import { useLayoutState } from 'shared/components/layout/useLayoutState';
import { BreadcrumbItem } from 'types';

const breadcrumbs: BreadcrumbItem[] = [
  {
    key: 'main',
    label: 'Main',
    path: '/',
  },
  {
    key: 'pricing',
    label: 'Pricing',
  },
  {
    key: 'contractList',
    label: 'Contracts',
    path: PricingRoutes.ContractList,
  },
  {
    key: 'contractEdit',
    label: 'Edit Contract',
  },
];

function ContractEditContent() {
  const { contractId }: PricingRouteContractEditParams = useParams();
  const { dispatch: dispatchLayout } = useLayoutState();
  const { state, dispatch } = useContractState();
  const { loading } = state;
  const [contractNotFound, setContractNotFound] = useState(false);

  useEffect(() => {
    dispatchLayout({ type: 'SET_BREADCRUMBS', breadcrumbs });
    dispatch({ type: 'SET_CONTRACT_MODE', contractMode: 'edit' });
    dispatch({ type: 'LOADING_CONTRACT' });
    fetchContract(Number(contractId)).then((contract) => {
      dispatch({ type: 'SET_CONTRACT', contract });
      setContractNotFound(!contract);
    });
  }, []);

  return (
    <main data-testid={testId.pricingPageContractEdit}>
      <section data-testid={testId.pricingLayoutPageHeader}>
        <PricingLayoutPageHeaderStyled
          title="Edit Contract"
          extra={!contractNotFound && !loading && <ContractEditHeaderAction />}
        />
      </section>
      {loading ? (
        <LoadingPage />
      ) : contractNotFound ? (
        <ContractNotFound />
      ) : (
        <ContractForm />
      )}
    </main>
  );
}

export default ContractEditContent;
